function setupVariantDependencyFilter() {
  var productJson = document.querySelector('[id^="ProductJson-"]');
  if (!productJson) return;

  var productData;
  try {
    productData = JSON.parse(productJson.textContent);
  } catch (e) {
    return;
  }

  var variants = productData.variants;

  var mapValid = {};
  variants.forEach(function (v) {
    var a = v.options[0];
    var b = v.options[1];
    if (!mapValid[a]) mapValid[a] = new Set();
    mapValid[a].add(b);
  });

  function applyFiltering() {
    var firstInputs = document.querySelectorAll('[data-option-position="1"]');
    var secondInputs = document.querySelectorAll('[data-option-position="2"]');

    if (firstInputs.length === 0 || secondInputs.length === 0) return;

    // Stokta olmayan varyantlar için sadece class ekle
    variants.forEach(function (variant) {
      if (!variant.available) {
        var opt2 = variant.options[1];

        secondInputs.forEach(function (input) {
          var label = document.querySelector('label[for="' + input.id + '"]');
          var labelText = label && label.innerText.trim();

          if (labelText === opt2) {
            label && label.classList.add('block-swatch', 'is-disabled');
          }
        });
      }
    });

   function updateSecondOptions(chosenFirst) {
  var allowedSet = mapValid[chosenFirst] || new Set();

  secondInputs.forEach(function (input) {
    var label = document.querySelector('label[for="' + input.id + '"]');
    var labelText = label && label.innerText.trim();

    if (allowedSet.has(labelText)) {
      input.disabled = false;
      label && label.classList.remove('is-disabled');

      // 🔍 Seçili Option1 + Option2 kombinasyonu stokta mı?
      var matchingVariant = variants.find(function (v) {
        return v.options[0] === chosenFirst && v.options[1] === labelText;
      });

      if (matchingVariant && !matchingVariant.available) {
        label && label.classList.add('is-disabled');
        label && label.setAttribute('title', 'Bu kombinasyon stokta yok');
      }
    } else {
      input.disabled = true;
      label && label.classList.add('is-disabled');
      if (input.checked) input.checked = false;
    }
  });

  // 🔁 Otomatik seçim (eğer mevcut seçim yoksa)
  var currentChecked = document.querySelector('[data-option-position="2"]:checked');
  if (!currentChecked || currentChecked.disabled) {
    for (const input of secondInputs) {
      if (!input.disabled) {
        input.checked = true;
        break;
      }
    }
  }
}



    firstInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var label = document.querySelector('label[for="' + input.id + '"]');
        var chosen = label && label.innerText.trim();
        updateSecondOptions(chosen);
      });
    });

    var checked1 = document.querySelector('[data-option-position="1"]:checked');
    if (checked1) {
      var label = document.querySelector('label[for="' + checked1.id + '"]');
      var selected = label && label.innerText.trim();
      updateSecondOptions(selected);
    }
  }

  applyFiltering();
}

document.addEventListener('variant:change', function () {
  setupVariantDependencyFilter();
});

document.addEventListener('DOMContentLoaded', function () {
  setupVariantDependencyFilter();
});
